module.exports = __webpack_public_path__ + "static/media/splash-pt.2d8851d1.jpg";